import { useNavigate } from "react-router-dom";
import "./AboutAdv.scss";
import React from "react";

export default function AboutAdv() {
  const navigate = useNavigate();
  return (
    <section className="full-page centered-container" id="about-adv">
      <div className="card col-start">
        <h1>Play the Online adventure</h1>
        <p>
          Each purchase of a Kalendar gives you access to our 25 day online
          adventure. This is a full story containing mysteries, combat and a
          chance to test your new dice.
        </p>
        <p>
          This year's adventure will start on the first of December and last
          year's adventure will be available starting in November
        </p>
      </div>
      <div className="card col-start">
        <p>Click below to try a short demo of last year's adventure</p>
        <button onClick={() => navigate("/adventure/demo")}>Demo</button>
      </div>
    </section>
  );
}
